import { Suspense } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { publicRoutes } from "./config/routerConfig";
import { ScrollToTop } from "./ScrollToTop";
import { ScrollToHash } from "./ScrollToHash";

const buildRoutes = (routes) =>
  routes.map((route) => ({
    path: route.path,
    index: route.index,
    element: <route.Component />,
    children: route.children ? buildRoutes(route.children) : undefined,
  }));

const AppRoutes = () => {
  const routes = buildRoutes(publicRoutes);
  return useRoutes(routes);
};

export const RouterProvider = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollToHash />
      <Suspense fallback={<div>Loading...</div>}>
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
};
